import { EmailVerificationScreenComponent } from './components/email-verification-screen/email-verification-screen.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { NewPasswordComponent } from './components/new-password/new-password.component';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { InitialPageGuardService } from '../../core/router/initial-page-guard.service';
import { TwoFactorScreenComponent } from '../../shared/modules/two-factor/components/two-factor-screen/two-factor-screen.component';
import { TwoFactorUnlockComponent } from '../../shared/modules/two-factor/components/two-factor-unlock/two-factor-unlock.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import type { Routes } from '@angular/router';

export const loginRoutes: Routes = [
  {
    path: '',
    canActivate: [InitialPageGuardService],
    children: [
      // NOTE(mike): This is here just to recognize the jwt token in
      // the url. But because we are getting the jwt in app state the
      // :jwt url param is not used in login component.
      { path: 'login/:jwt', component: LoginComponent },
      { path: 'login', component: LoginComponent },
      // NOTE(mike): Normally backend should not redirect to these routes, because
      // if the user successfully authenticated with the IDP and everything is ok, the
      // user should be logged in after the IDP redirects the user to our backend.
      // But our application needs to handle these routes, because if something went
      // wrong, backend will serve our application under these routes and will also set
      // some error code in app state. In that case we show the login screen and some
      // error message, explaining what went wrong to the user.
      { path: 'saml/:id/idp_login', component: LoginComponent },
      { path: 'openid/:id/idp_login', component: LoginComponent },
      { path: 'forgot_password', component: ForgotPasswordComponent },
      { path: 'new_password/:hash', component: NewPasswordComponent },
      { path: 'welcome/:jwt', component: WelcomeScreenComponent },
      // NOTE(mike): For now just because of backward compatibility. `token` was insecure and
      // was removed. The `token` from url is not used.
      // Invite link from CRM
      { path: 'welcome/:user_id/:token', component: WelcomeScreenComponent },
      // NOTE(mike): For now just because of backward compatibility. `token` was insecure and
      // was removed. The `token` from url is not used.
      // Invite link from Workspace (Customer Portal)
      { path: 'welcome/subscription/:user_id/:token', component: WelcomeScreenComponent },
      { path: '2fa/unlock', component: TwoFactorUnlockComponent },
      { path: '2fa/:jwt', component: TwoFactorScreenComponent },
      { path: 'email-verification/:jwt', component: EmailVerificationScreenComponent },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(loginRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class LoginRoutingModule { }
